import React from 'react';
import { CheckCircle, Award } from 'lucide-react';

const TIER_CONFIG = {
  1: { label: 'Self-Attested',     color: '#9CA3AF', icon: '✓',   title: 'Basic profile — email not yet verified' },
  2: { label: 'Verified',          color: '#2563EB', icon: '✓',   title: 'Email and employer verified' },
  3: { label: 'License Verified',  color: '#D97706', icon: '⭐',  title: 'Producer license verified via NIPR' },
  4: { label: 'Employer Confirmed',color: '#7C3AED', icon: '⬡',  title: 'Employment confirmed by company admin' },
};

export default function VerificationBadge({ tier = 1, size = 'md', showLabel = false }) {
  const config = TIER_CONFIG[tier] || TIER_CONFIG[1];

  const sizes = {
    sm:  { icon: 12, font: '10px', padding: '1px 5px' },
    md:  { icon: 14, font: '11px', padding: '2px 7px' },
    lg:  { icon: 16, font: '12px', padding: '3px 9px' },
  };
  const s = sizes[size] || sizes.md;

  if (!showLabel) {
    return (
      <span
        title={config.title}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          marginLeft: '4px',
          color: config.color,
          fontSize: s.icon,
          cursor: 'help',
        }}
      >
        {tier >= 2 ? <CheckCircle size={s.icon} fill={config.color} color="white" /> : null}
        {tier === 3 ? <Award size={s.icon} style={{ marginLeft: 2 }} /> : null}
      </span>
    );
  }

  return (
    <span
      className={`badge badge-tier-${tier}`}
      title={config.title}
      style={{
        fontSize: s.font,
        padding: s.padding,
        cursor: 'help',
      }}
    >
      {config.label}
    </span>
  );
}
